module.exports = __webpack_public_path__ + "img/icon.78b5b70a.png";